import { useSyncExternalStore } from 'react';
import { apiLog  } from '@/lib/api-log';
import type {ApiCall} from '@/lib/api-log';

/**
 * Abonne un composant React au journal des appels d'API.
 *
 * `useSyncExternalStore` est le hook officiel pour lire un état qui vit hors
 * de React (ici, notre magasin en mémoire). Il garantit que le rendu reste
 * cohérent même en mode concurrent, ce qu'un `useState` + `useEffect` ne
 * garantit pas.
 */
export function useApiLog(): ApiCall[] {
    return useSyncExternalStore(apiLog.subscribe, apiLog.getSnapshot, apiLog.getSnapshot);
}
